import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { injectGlobal, ThemeProvider } from 'styled-components';

import { isDev } from 'config';
import { HomePage, NotFoundPage, ReservationPage, DemoPage, PerfProfiler } from 'components';

import theme from './themes/default';

import './themes/main.css';

injectGlobal`
  body {
    margin: 0;
  }
`;

const App = () => (
  <div>
    <ThemeProvider theme={theme}>
      <Switch>
        <Route path="/" component={HomePage} exact />
        <Route path="/demo" component={DemoPage} />
        <Route path="/reservations/:reservation/:lang" component={ReservationPage} />
        <Route path="/reservations/:reservation" component={ReservationPage} />
        <Route component={NotFoundPage} />
      </Switch>
    </ThemeProvider>
    { isDev && <PerfProfiler />}
  </div>
  );

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js